export const createCheckboxsString = (data) => {
    data.forEach((item => {
        if (item.links) {
            item.links.forEach(link => {
                let isContains = item.content.includes(link.text);
                if (isContains) {
                    let linkContent = `<a target="_blank" href="${link.url}">${link.text}</a>`
                    item.content = item.content.replace(link.text, linkContent)
                }
            })
        }
    }))

    return `${data.map((item) => `<div class="checkbox-group position-relative"><label for="${item.consentDefinitionId}">
            <input    ${item.required ? 'checked' : ''}  data-id="${item.consentDefinitionId}" type="checkbox" name="${item.consentDefinitionId}" id="${item.consentDefinitionId}">
            <span class="checkmark"></span>${item.content}
                </label></div>`).join('')}`;
}

export const createCheckboxsStringForMember = (data) => {
    return `${data.map((item) => `<div class="checkbox-group position-relative"><label for="${item.consentId}">
            <input    data-required="${item.required}"   ${item.isActive ? 'checked' : ''}  data-id="${item.consentId}" type="checkbox" name="agree" id="${item.consentId}">
            <span class="checkmark"></span>${item.content}
                </label></div>`).join('')}`;
}